module.exports = __webpack_public_path__ + "img/形状映射.4b25ce11.svg";